var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBacklogIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1124_47652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9999,24.9999V21.4999H23.9999V24.9999Z",
    rx: 1,
    strokeLinejoin: "round",
    stroke: "#667085",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9999,11.9999V8.5L23.9999,8.5V11.9999Z",
    rx: 1,
    strokeLinejoin: "round",
    stroke: "#667085",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999,18.5V14.9999H23.9999V18.5Z",
    rx: 1,
    strokeLinejoin: "round",
    stroke: "#667085",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1124_47652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 4 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklogIcon);
export default __webpack_public_path__ + "static/media/backlog-icon.131b609b3852813df804038560f76cb9.svg";
export { ForwardRef as ReactComponent };